"use strict";

var _regeneratorRuntime = require("/opt/buildhome/repo/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RestManager = void 0;

var cross_fetch_1 = __importDefault(require("cross-fetch"));

var KnightHacksAPIError_1 = require("./KnightHacksAPIError");

var api_1 = require("./util/api");

var RestManager = /*#__PURE__*/function () {
  function RestManager() {
    _classCallCheck(this, RestManager);

    this.baseURL = 'https://api.knighthacks.org/api';
  }

  _createClass(RestManager, [{
    key: "performRequest",
    value: function performRequest(path, init) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, cross_fetch_1.default)(this.baseURL + path, init);

              case 2:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 6;
                  break;
                }

                _context.next = 6;
                return this.handleAPIError(response, path);

              case 6:
                return _context.abrupt("return", (0, api_1.parseResponse)(response));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "handleAPIError",
    value: function handleAPIError(response, path) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var json, error;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return response.json();

              case 2:
                json = _context2.sent;

                if (json) {
                  _context2.next = 5;
                  break;
                }

                throw new Error("Error performing request for endpoint: ".concat(response.url));

              case 5:
                error = new KnightHacksAPIError_1.KnightHacksAPIError(json, response.url, path);
                throw error;

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }]);

  return RestManager;
}();

exports.RestManager = RestManager;